import { render, staticRenderFns } from "./VekaletInfo.vue?vue&type=template&id=0deaa894&scoped=true"
import script from "./VekaletInfo.vue?vue&type=script&lang=ts"
export * from "./VekaletInfo.vue?vue&type=script&lang=ts"
import style0 from "./VekaletInfo.vue?vue&type=style&index=0&id=0deaa894&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0deaa894",
  null
  
)

export default component.exports